// extracted by mini-css-extract-plugin
export var boldText = "_3j-4";
export var checkboxContainer = "_3j-6";
export var closeIcon = "_3j-g";
export var container = "_3j-0";
export var drawer = "_3j-8";
export var drawerContent = "_3j-9";
export var extraSmallText = "_3j-5";
export var fulfillmentGroupTable = "_3j-e";
export var largeText = "_3j-3";
export var loadingSpinnerContainer = "_3j-h";
export var mediumText = "_3j-2";
export var narrow = "_3j-f";
export var notificationLink = "_3j-j";
export var packageCheckIconContainer = "_3j-7";
export var slideoutHeaderContainer = "_3j-a";
export var slideoutModal = "_3j-c";
export var stickyHeaderWrapper = "_3j-b";
export var table = "_3j-i";
export var tableContainer = "_3j-d";
export var tertiaryText = "_3j-1";